import axios from "axios";
import { authHeaderJson, authHeaderFile } from "./auth-header.service";

const getBulkUsersTemplate = (clientId) => {
  return axios.post(`/api/account/register-bulk-template?clientId=${encodeURIComponent(clientId)}`, null, { headers: authHeaderJson() });
};

const postBulkUsers = (clientId, file) => {
  const data = new FormData();
  data.append('ClientId', clientId);
  data.append('file', file);

  return axios.post(`/api/account/register-bulk`, data, { headers: authHeaderFile() });
};

const postBulkUsersEmail = (clientId, file) => {
  const data = new FormData();
  data.append('ClientId', clientId);
  data.append('file', file);

  return axios.post(`/api/account/send-creation-email-bulk`, data, { headers: authHeaderFile() });
};

export default {
  getBulkUsersTemplate,
  postBulkUsers,
  postBulkUsersEmail
};
